import React, { useContext, useState } from "react";
import { Alert, Button, Checkbox, Form, Spin } from "antd";
import { makeApiRequest } from "../../lib/api";
import { useTranslation } from "react-i18next";
import { GlobalStateContext } from "../../lib/GlobalContext";
import { defaultLinkAGB, defaultLinkDP } from "../../lib/config";

interface DisclaimerFormProps {
  params: any;
}

const EgwDisclaimerForm: React.FC<DisclaimerFormProps> = ({ params }) => {
  const { state, authenticate } = useContext(GlobalStateContext);
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const linkDP = params.linkDP ? params.linkDP : defaultLinkDP;
  const linkAGB = params.linkAGB ? params.linkAGB : defaultLinkAGB;

  if (state.user?.agb_accepted && state.user?.data_protection) {
    return <div>{t("disclaimer.error")}</div>;
  }

  if (!state.user) {
    return <div>{t("disclaimer.error")}</div>;
  }

  const onFinish = async (values: any) => {
    setError("");
    setLoading(true);
    console.log("onFinish", values);
    try {
      const response = await makeApiRequest(params, "REACT_ACCEPT_DISCLAIMER", values);
      const parsedResponse = JSON.parse(response);
      if (!parsedResponse || parsedResponse.STATUS !== "OK") {
        setError(t("disclaimer.error"));
        setLoading(false);
        return;
      }
      if (parsedResponse && parsedResponse.CONTENT) {
        console.log("DEBUG: parsedResponse", parsedResponse.CONTENT);
      }
      authenticate(parsedResponse.CONTENT);
    } catch (err) {
      setError(t("disclaimer.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && (
        <div className="my-lg">
          <Spin />
        </div>
      )}

      {error && <Alert message={t("kundenbereich.disclaimerForm.error")} description={error} type="error" showIcon />}
      {/* {success && <Alert message={t("disclaimer.successTitle")} description={t("disclaimer.successMessage")} type="success" showIcon />} */}

      <h4>{t("kundenbereich.disclaimerForm.title")}</h4>
      <p>{t("kundenbereich.disclaimerForm.description")}</p>
      <br />

      <Form form={form} name="disclaimerForm" onFinish={onFinish} layout="vertical" style={{ maxWidth: 600 }}>
        {!state.user?.agb_accepted && (
          <>
            <Form.Item name="agb" valuePropName="checked" rules={[{ required: true, message: t("kundenbereich.disclaimerForm.agbError") }]}>
              <Checkbox>
                {t("anpassung.registration.agbText")}{" "}
                <a href={linkAGB} target="_blank" rel="noreferrer">
                  {t("anpassung.registration.agbLink")}
                </a>{" "}
                {t("anpassung.registration.agbConfirmation")}
              </Checkbox>
            </Form.Item>
          </>
        )}

        {!state.user?.data_protection && (
          <>
            <Form.Item
              name="dataProtection"
              valuePropName="checked"
              rules={[{ required: true, message: t("kundenbereich.disclaimerForm.dataProtectionError") }]}
            >
              <Checkbox>
                {t("anpassung.registration.dataProtectionText")}{" "}
                <a href={linkDP} target="_blank" rel="noreferrer">
                  {t("anpassung.registration.dataProtectionLink")}
                </a>{" "}
                {t("anpassung.registration.dataProtectionConfirmation")}
              </Checkbox>
            </Form.Item>
          </>
        )}

        <Form.Item>
          <br />
          <br />
          <Button type="primary" htmlType="submit" disabled={loading}>
            {t("kundenbereich.disclaimerForm.submit")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default EgwDisclaimerForm;
